export enum AuthEnum {
  TOKEN_KEY = '$2a$12$Ax8hMMduYIOgewuAgf3KPTH8i8gD6yiS3ZZe3cTI',
  USER_KEY = '@HappyCodeAcademy/login',
}
